import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';

import { Socio } from '../model/Socio';


import { UtilitiesService } from '../services/utilities.service'

@Injectable()
export class SocioService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService
    ) { }


  getSocios(query: any) : Observable<Socio[]> {
       
    let json = {   "Metodo": "findSocio",   "Datos":  query};
    
    let params = "Data="+ JSON.stringify(json);
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  }

  public insert(socio: Socio){
   
    let json = {   "Metodo": "postSocio",   "Datos": socio  };

    let params = "Data="+ JSON.stringify(json);
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}

public delete(socio: Socio){
   
    let json = {   "Metodo": "deleteSocio",   "Datos": socio  };

    let params = "Data="+ JSON.stringify(json);
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());

}


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/socio.service.ts